import {Box, Card, CardContent, Grid, TextField, Typography} from "@material-ui/core";
import {LocationAutocomplete} from "../../../../../../components/LocationAutocomplete";
import GoogleMapBlock from "../components/GoogleMapBlock";
import React, {FC, useState} from "react";
import {decodePin} from "../../../../../../utils/functions";
import {FormikErrors} from "formik";

type PropsType = {
  values: any
  setValues: (values: any) => void
  initialValues: any
  errors: any
  handleChange: {(e: React.ChangeEvent<any>): void, <T_1=string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : ((e: (string | React.ChangeEvent<any>)) => void)}
}

const CompanyAddressSection: FC<PropsType> = ({
  values,
  setValues,
  handleChange,
  initialValues,
  errors
}) => {
  const [point, setPoint] = useState({lat: 59.3293, lng: 18.0686})

  const onDragEnd = async (val: any) => {
    try {
      const center = {
        lat: val.center.lat(),
        lng: val.center.lng()
      }
      const data = await decodePin(center);
      if (data) {
        let address = values.address
        address.address_line_1 = data.formatted_address
        data.address_components.forEach((item: any) => {
          if (item.types.includes('locality') || item.types.includes('postal_town')) {
            address.city = item.long_name
          }
          if (item.types.includes('country')) {
            address.country = item.short_name
          }
          if (item.types.includes('postal_code')) {
            address.postcode = item.short_name
          }
        })
        setValues({
          ...values,
          address: address
        })
      }
    } catch (e) {
      console.error('error', e)
    }
  }


  return (
    <Card>
      <CardContent>
        <Typography variant="h6" style={{ marginBottom: "20px" }}>
          2. Company address
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <LocationAutocomplete
              name={'address.address_line_1'}
              fullAddressError={!!errors.address?.address_line_1}
              validAddress={true}
              value={values.address.address_line_1}
              isValidAddress={() => {}}
              onConfirmLocation={obj => {
                const { addressData, latLng } = obj;
                setValues({
                  ...values,
                  address: {
                    ...values.address,
                    address_line_1: addressData.full_address,
                    city: addressData.city,
                    country: addressData.country_code,
                    postcode: addressData.postcode
                  },
                })
                setPoint({
                  lat: latLng.lat,
                  lng: latLng.lng
                })
              }}
            />
            <Box mt={3}>
              <TextField
                id={'floor'} name={'address.floor'} label={'Floor'}
                value={values.address.floor}
                variant={'outlined'}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={5}>
              <TextField
                id={'office_number'} name={'address.office_number'} label={'Office number'}
                value={values.address.office_number}
                variant={'outlined'}
                onChange={handleChange}
                fullWidth
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <GoogleMapBlock
              lat={point.lat}
              lng={point.lng}
              onDragEnd={onDragEnd}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
export default CompanyAddressSection